import { G, GL, GB, BLACK, MID, LIGHT, BORDER, BG } from "../constants";
import { renderWithExclusions } from "./shared";

export function PreviewPanels({ p, openPrev, setOpenPrev, generatedCopy = {} }) {
  const tabs = ["Google Search", "Google Shopping", "LLM / ChatGPT"];
  const active = openPrev[p.id] ?? "Google Search";
  const setTab = t => setOpenPrev({ ...openPrev, [p.id]: t });

  const brandDomain = p.brand.toLowerCase().replace(/\s/g, "") + ".com";

  return (
    <div style={{ borderTop: `1px solid ${BORDER}` }}>
      {/* Header */}
      <div style={{ padding: "12px 16px 0", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
        <div style={{ fontSize: 10, fontWeight: 700, color: LIGHT, letterSpacing: "0.6px", textTransform: "uppercase" }}>
          CHANNEL PREVIEWS
        </div>
        {/* Tabs */}
        <div style={{ display: "flex", gap: 0, border: `1px solid ${BORDER}`, borderRadius: 6, overflow: "hidden" }}>
          {tabs.map(t => (
            <button key={t} onClick={() => setTab(t)}
              style={{ border: "none", background: active === t ? G : BG, color: active === t ? "#fff" : MID, padding: "5px 13px", fontSize: 11, fontWeight: 700, cursor: "pointer", fontFamily: "inherit", borderRight: `1px solid ${BORDER}`, transition: "background 0.1s" }}>
              {t}
            </button>
          ))}
        </div>
      </div>

      <div style={{ padding: "14px 16px 16px" }}>

        {/* ── Google Search SERP ── */}
        {active === "Google Search" && (
          <div style={{ border: `1px solid ${BORDER}`, borderRadius: 8, overflow: "hidden", background: "#fff" }}>
            {/* Browser chrome */}
            <div style={{ background: "#f1f3f4", borderBottom: `1px solid ${BORDER}`, padding: "8px 12px", display: "flex", alignItems: "center", gap: 8 }}>
              <div style={{ display: "flex", gap: 5 }}>
                {["#ff5f57","#febc2e","#28c840"].map(c => <div key={c} style={{ width: 8, height: 8, borderRadius: "50%", background: c }} />)}
              </div>
              <div style={{ flex: 1, background: "#fff", border: `1px solid ${BORDER}`, borderRadius: 12, padding: "3px 12px", fontSize: 11, color: "#555", maxWidth: 380 }}>
                google.com/search?q={p.signalsUsed[0]?.replace(/\s/g, "+")}
              </div>
            </div>
            <div style={{ padding: "10px 16px 4px", fontSize: 11, color: LIGHT }}>
              About 4,200,000 results (0.41 seconds)
            </div>
            {/* Highlighted result */}
            <div style={{ padding: "12px 16px 16px", borderLeft: `3px solid ${G}`, background: "#f9fffe", margin: "0 16px 8px", borderRadius: "0 6px 6px 0" }}>
              <div style={{ fontSize: 11, color: "#3c4043", marginBottom: 3, display: "flex", alignItems: "center", gap: 6 }}>
                <div style={{ width: 14, height: 14, borderRadius: 3, background: G, display: "flex", alignItems: "center", justifyContent: "center" }}>
                  <span style={{ color: "#fff", fontSize: 7, fontWeight: 900 }}>SC</span>
                </div>
                {brandDomain} › products › {p.title.toLowerCase().replace(/\s/g,"-")}
                <span style={{ fontSize: 10, fontWeight: 700, background: "#f0faf4", color: G, border: `1px solid ${GB}`, borderRadius: 3, padding: "1px 5px" }}>✓ Optimised</span>
              </div>
              <div style={{ fontSize: 16, color: "#1a0dab", fontWeight: 400, marginBottom: 4, lineHeight: 1.3 }}>
                {generatedCopy[p.id]?.optimised_title || p.optimisedTitle || p.title}
              </div>
              <div style={{ fontSize: 13, color: "#4d5156", lineHeight: 1.55 }}>
                {(generatedCopy[p.id]?.optimised_description || p.optimisedDesc || p.description || "").slice(0, 160).replace(/\n/g, " ")}…
              </div>
            </div>
            {/* Faded competitors */}
            {[
              { url: "competitor-a.com", title: p.title, desc: `Shop ${p.title.toLowerCase()} at competitive prices. Free delivery on orders over £50.` },
              { url: "competitor-b.co.uk", title: `Men's ${p.title}`, desc: `Browse our range of ${p.title.toLowerCase()}. Available in multiple sizes and colours.` },
            ].map((r, i) => (
              <div key={i} style={{ padding: "10px 16px", opacity: 0.35, borderTop: `1px solid ${BORDER}` }}>
                <div style={{ fontSize: 11, color: "#3c4043", marginBottom: 2 }}>{r.url}</div>
                <div style={{ fontSize: 15, color: "#1a0dab", marginBottom: 3 }}>{r.title}</div>
                <div style={{ fontSize: 13, color: "#4d5156" }}>{r.desc}</div>
              </div>
            ))}
            <div style={{ padding: "8px 16px", background: "#f0faf4", borderTop: `1px solid ${GB}` }}>
              <span style={{ fontSize: 11, color: G, fontWeight: 700 }}>↑ Optimised title and description drive position 1 ranking for "{p.signalsUsed[0]}"</span>
            </div>
          </div>
        )}

        {/* ── Google Shopping ── */}
        {active === "Google Shopping" && (
          <div style={{ border: `1px solid ${BORDER}`, borderRadius: 8, overflow: "hidden", background: "#fff" }}>
            <div style={{ background: "#f1f3f4", borderBottom: `1px solid ${BORDER}`, padding: "8px 12px", display: "flex", alignItems: "center", gap: 8 }}>
              <div style={{ display: "flex", gap: 5 }}>
                {["#ff5f57","#febc2e","#28c840"].map(c => <div key={c} style={{ width: 8, height: 8, borderRadius: "50%", background: c }} />)}
              </div>
              <div style={{ flex: 1, background: "#fff", border: `1px solid ${BORDER}`, borderRadius: 12, padding: "3px 12px", fontSize: 11, color: "#555", maxWidth: 380 }}>
                google.com/search?tbm=shop&q={p.signalsUsed[0]?.replace(/\s/g, "+")}
              </div>
            </div>
            <div style={{ padding: "8px 12px", fontSize: 11, fontWeight: 700, color: LIGHT, textTransform: "uppercase", letterSpacing: "0.5px", borderBottom: `1px solid ${BORDER}`, background: "#fafafa" }}>
              Shopping results
            </div>
            <div style={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: 1, background: BORDER }}>
              {/* Highlighted card */}
              <div style={{ background: "#fff", padding: "12px", border: `2px solid ${G}` }}>
                <div style={{ width: "100%", aspectRatio: "1", background: "linear-gradient(135deg,#f3f4f6,#e5e7eb)", borderRadius: 6, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 24, marginBottom: 8 }}>🧥</div>
                <div style={{ fontSize: 10, color: LIGHT, fontWeight: 600, textTransform: "uppercase", marginBottom: 2 }}>{p.brand}</div>
                <div style={{ fontSize: 11, fontWeight: 700, lineHeight: 1.35, marginBottom: 5, color: BLACK }}>{(generatedCopy[p.id]?.optimised_title || p.optimisedTitle || p.title).split("|")[0].trim()}</div>
                <div style={{ fontSize: 13, fontWeight: 800 }}>£85.00</div>
                <div style={{ fontSize: 10, color: "#f59e0b", marginTop: 2 }}>★★★★★ <span style={{ color: LIGHT }}>4.8</span></div>
                <div style={{ fontSize: 10, background: "#f0faf4", color: G, fontWeight: 700, padding: "2px 6px", borderRadius: 3, marginTop: 4, display: "inline-block" }}>✓ GMC 91/100</div>
              </div>
              {[
                { title: p.title, price: "£79.00", stars: "★★★★", rating: "4.1" },
                { title: `Men's ${p.title} - Fleece`, price: "£65.00", stars: "★★★", rating: "3.8" },
                { title: p.title.split(" ").reverse().join(" "), price: "£72.00", stars: "★★★★", rating: "3.9" },
              ].map((c, i) => (
                <div key={i} style={{ background: "#fff", padding: "12px", opacity: 0.4 + (i * 0.05) }}>
                  <div style={{ width: "100%", aspectRatio: "1", background: "#f3f4f6", borderRadius: 6, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 24, marginBottom: 8 }}>🧥</div>
                  <div style={{ fontSize: 10, color: LIGHT, fontWeight: 600, textTransform: "uppercase", marginBottom: 2 }}>Brand {String.fromCharCode(66+i)}</div>
                  <div style={{ fontSize: 11, fontWeight: 600, lineHeight: 1.35, marginBottom: 5 }}>{c.title}</div>
                  <div style={{ fontSize: 13, fontWeight: 800 }}>{c.price}</div>
                  <div style={{ fontSize: 10, color: "#f59e0b", marginTop: 2 }}>{c.stars} <span style={{ color: LIGHT }}>{c.rating}</span></div>
                </div>
              ))}
            </div>
            <div style={{ padding: "8px 16px", background: "#f0faf4", borderTop: `1px solid ${GB}` }}>
              <span style={{ fontSize: 11, color: G, fontWeight: 700 }}>↑ Complete GMC attributes + keyword-matched title = position 1 Shopping placement</span>
            </div>
          </div>
        )}

        {/* ── LLM / ChatGPT ── */}
        {active === "LLM / ChatGPT" && (
          <div style={{ border: `1px solid ${BORDER}`, borderRadius: 8, overflow: "hidden", background: "#fff" }}>
            <div style={{ background: "#f7f7f8", borderBottom: `1px solid ${BORDER}`, padding: "8px 12px", display: "flex", alignItems: "center", gap: 8 }}>
              <div style={{ display: "flex", gap: 5 }}>
                {["#ff5f57","#febc2e","#28c840"].map(c => <div key={c} style={{ width: 8, height: 8, borderRadius: "50%", background: c }} />)}
              </div>
              <div style={{ fontSize: 12, fontWeight: 700, color: "#555", marginLeft: 4 }}>ChatGPT</div>
            </div>
            <div style={{ padding: "16px 18px" }}>
              {/* User query */}
              <div style={{ background: "#f3f4f6", borderRadius: 8, padding: "10px 14px", fontSize: 13, color: BLACK, marginBottom: 16, borderLeft: `3px solid ${G}` }}>
                <div style={{ fontSize: 10, fontWeight: 700, color: LIGHT, textTransform: "uppercase", letterSpacing: "0.5px", marginBottom: 4 }}>User</div>
                What's the best {p.signalsUsed[0]} in the UK? I want something with {p.signalsUsed[2] ?? "quality construction"}.
              </div>
              {/* LLM response */}
              <div style={{ fontSize: 13, color: MID, lineHeight: 1.75, marginBottom: 14 }}>
                Here are some strong options - the kind of picks that tend to come up repeatedly in r/malefashion and r/streetwear:
              </div>
              {/* Highlighted recommendation */}
              <div style={{ border: `1px solid ${GB}`, borderRadius: 8, padding: "12px 14px", background: "#f0faf4", marginBottom: 8, display: "flex", gap: 12, alignItems: "flex-start" }}>
                <div style={{ width: 40, height: 40, borderRadius: 6, background: "#d4ead9", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 18, flexShrink: 0 }}>🧥</div>
                <div>
                  <div style={{ fontSize: 13, fontWeight: 700, marginBottom: 3 }}>
                    {p.brand} - {p.title}
                    <span style={{ marginLeft: 8, fontSize: 11, background: "#f0faf4", color: G, border: `1px solid ${GB}`, borderRadius: 4, padding: "1px 7px", fontWeight: 700 }}>{brandDomain} ↗</span>
                  </div>
                  <div style={{ fontSize: 12, color: MID, lineHeight: 1.55, marginBottom: 5 }}>
                    {(generatedCopy[p.id]?.optimised_description || p.optimisedDesc || p.description || "").split("\n")[0].slice(0, 140)}…
                  </div>
                  <div style={{ fontSize: 11, color: G, fontWeight: 700 }}>
                    ✓ Matched on: {p.signalsUsed.slice(0, 3).map(s => `"${s}"`).join(" · ")}
                  </div>
                </div>
              </div>
              {/* Faded second result */}
              <div style={{ border: `1px solid ${BORDER}`, borderRadius: 8, padding: "10px 14px", display: "flex", gap: 12, alignItems: "flex-start", opacity: 0.45 }}>
                <div style={{ width: 40, height: 40, borderRadius: 6, background: "#f3f4f6", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 18, flexShrink: 0 }}>🧥</div>
                <div>
                  <div style={{ fontSize: 13, fontWeight: 700, marginBottom: 3 }}>Brand B - Similar {p.title}</div>
                  <div style={{ fontSize: 12, color: MID }}>A decent alternative at a lower price point, though fewer consumer signal matches.</div>
                </div>
              </div>
            </div>
            <div style={{ padding: "8px 16px", background: "#f0faf4", borderTop: `1px solid ${GB}` }}>
              <span style={{ fontSize: 11, color: G, fontWeight: 700 }}>↑ Reddit-matched consumer language in description triggers LLM recommendation. This is AEO.</span>
            </div>
          </div>
        )}

      </div>
    </div>
  );
}

